<script>
import { mapGetters } from "vuex";
import { getCurrentTime, IsNullOrEmpty, IsDevSim } from "@/modules/helper/index";
import { isPhoneGap } from '@/modules/util/util'
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    defaultValue: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: ""
    },
    value: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: "" // default
    }
  },
  data() {
    return {
      pickerelement: null
    };
  },
  computed: {
    ...mapGetters(["language", "resource"]),
    pickerId() {
      return "picker-time-" + this.index;
    },
    defaultTime() {
      let time;
      if (this.defaultValue === "current") {
        time = getCurrentTime();
      } else if (this.defaultValue === "time") {
        time = this.time ? this.time : "00:00";
      } else {
        time = null;
      }
      return time != null ? time.split(":") : time;
    },
    defaultTimeValue() {
      if (IsDevSim()) {
        let time;
        if (this.defaultValue === "current") {
          time = getCurrentTime();
        } else if (this.defaultValue === "time") {
          time = this.time ? this.time : "00:00";
        } else {
          time = null;
        }
        return time
      } else {
        return this.value
      }
      // return this.value
    },
    IsNullOrEmptyErrorMessage() {
      if (this.required && !IsNullOrEmpty(this.value)) {
        return true;
      }
    }
  },
  watch: {
    defaultValue: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createTimePicker();
    },
    time: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createTimePicker();
    },
    index: function(value, oldvalue) {
      if (value !== oldvalue && this.pickerelement) {
        this.pickerelement.destroy();
        this.pickerelement = null;
      }
      this.createTimePicker();
    }
  },
  methods: {
    createTimePicker() {
      let $this = this;
      this.pickerelement = this.$f7.picker.create({
        inputEl: "#" + this.pickerId,
        rotateEffect: true,
        toolbarCloseText: this.resource.doneBtn,
        openIn: "sheet",
        routableModals: false,
        value: this.defaultTime,

        on: {
          change: function(picker, values, displayValues) {
              $this.$emit("propChange", {
                value: values[0] + ":" + values[1]
              });
          },
          close: function(picker) {
            $this.$emit("propChange", {
              value: picker.value[0] + ":" + picker.value[1]
            });
          }
        },
        formatValue: function(values, displayValues) {
          return values[0] + " : " + values[1];
        },

        cols: [
          // Hours
          {
            values: (function() {
              var arr = [];
              for (var i = 0; i <= 23; i++) {
                arr.push(i < 10 ? "0" + i : i);
              }
              return arr;
            })()
          },
          // Divider
          {
            divider: true,
            content: ":"
          },
          // Minutes
          {
            values: (function() {
              var arr = [];
              for (var i = 0; i <= 59; i++) {
                arr.push(i < 10 ? "0" + i : i);
              }
              return arr;
            })()
          }
        ]
      });
    }
  },
  created () {
    this.$emit("propChange", {
      value: this.defaultTimeValue
    });
  },
  mounted() {
    this.createTimePicker();
  },
  beforeDestroy() {
    if (this.pickerelement) {
      this.pickerelement.destroy();
    }
  }
};
</script>
<template>
  <f7-list class="list-block inputs-list">
    <f7-list-item class="input-wrapper">
      <f7-label class="label-color">{{label}}</f7-label>
      <f7-input type="text" :placeholder="placeholder" :id="pickerId" v-model="defaultTimeValue" :readonly="true" class="input-value-color"></f7-input>
      <div v-if="errorMessage" class="color-red">{{errorMessage}}</div>
    </f7-list-item>
  </f7-list>
</template>
<style scoped>

.item-label {
  line-height: 15px !important;
}
.list {
  margin: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/form-control/TimeInput.vue